import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable()
export class JsonParseInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
    return next.handle(request).pipe( map( event => { 
      if (event instanceof HttpResponse && this.shouldBeIntercepted(event)) {
        event = event.clone({ body: event.body })
      }         
      return event;
    }));
  }

  shouldBeIntercepted(event: any): boolean {
    return true;
  }

  resolveReferences( body: string ): string {
    return body.replace("<!-- Generated by Webspeed: http://www.webspeed.com/ -->", "");
  }
}
